<template>
  <div id="service">

    <ServiceMobile v-if="!$store.state.isDesktop"
                   :openHours="openHours"
                   :service="service"
                   :schedules="Schedules"
                   :user="User"
                   :images="images"
                   :days="days"
                   :hasOpeningHours="hasOpeningHours"
    ></ServiceMobile>

    <ServiceDesktop v-if="$store.state.isDesktop"
                    :openHours="openHours"
                    :schedules="Schedules"
                    :service="service"
                    :user="User"
                    :images="images"
                    :days="days"
                    :hasOpeningHours="hasOpeningHours"
    ></ServiceDesktop>

  </div>
</template>

<script>

  import Services from '../../core/Services';
  import User from "../../core/User";
  import Schedules from "../../core/Schedules";
  import ServiceMobile from "../components/mobile/Service.vue";
  import ServiceDesktop from "../components/desktop/Service.vue";

  export default {

    name: "service",

    components: { ServiceMobile, ServiceDesktop },

    data() {
      return {
        Services,
        Schedules,
        User,
        days: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: this.service ? this.$to(this.service.name) : "menu.services",
        headerIcon: "/svg/services.svg"
      });
      setTimeout(()=>this.$forceUpdate(),0);
    },

    watch: {
      service() {
        this.$store.state.headerTitle = this.$to(this.service.name);
      },
      images() {
        setTimeout(()=>this.$forceUpdate(),0);
      }
    },

    computed: {
      openHours() {
        if (!this.service) {
          return [];
        }
        return this.days.map(day => ({day, ...this.service.hours[day]}))
      },
      service() {
        return this.Services.get(this.$route.params.id);
      },
      images() {
        if (this.service && this.service.images != null && this.service.images.length > 0) {
          return this.service.images.map(i => CONFIG.urlFiles + i);
        }
        return ["babillard.jpg"];
      },
      showContact() {
        return this.service && (this.service.phoneNumber || this.service.email || this.Schedules.getForService(this.service.id));
      },
      hasOpeningHours() {
        for(let day of this.days) {
          if(this.service && this.service.hours[day].hours.length > 0) {
            return true;
          }
        }
        return false;
      }
    }

  }

</script>

<style lang="scss">
  #service {
    display: flex;
    .section {
      display: flex;
      margin: 0 20px;
      padding: 12px 0 15px 0;
      &:not(:last-of-type) {
        border-bottom: 1px solid #d9dcde;
      }
      .leftIcon {
        width: 20px;
        margin-right: 20px;
        padding-top: 6px;
        text-align: center;
        .svgicon {
          fill: #808b91;
        }
      }
      .content {
        flex-grow: 1;
      }
      .subtitle {
        color: #bfc5c8;
        text-transform: uppercase;
        font-size: 12px;
      }
      .line {
        min-height: 45px;
        display: flex;
        align-items: center;
        margin-top: 4px;
        .grow {
          flex-grow: 1;
        }
        .arrow {
          width: 15px;
          margin-left: 15px;
          margin-top: -2px;
        }
      }
    }
  }

  #service .parent-section {
    .section {
      border-bottom: none;
      padding: 3px 0;
      align-items: center;

      &:first-child {
        padding-top: 15px;
      }

      &:last-child {
        padding-bottom: 15px;
        border-bottom: 1px solid #d9dcde;
      }
    }
  }

  ul {
    padding: 0;
    margin: 0 0 0 18px;
    list-style: square;

    li:not(:last-child) {
      padding-bottom: 2px;
    }
  }

  .documents {
    display: flex;
    flex-wrap: wrap;

    .document {
      width: calc(50% - 20px);
      margin: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f2f2f2;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      border-radius: 3px;

      .name {
        padding: 15px;
        font-size: 14px;
        flex-grow: 1;
        font-weight: bold;
      }

      .icon {
        min-height: 55px;
        height: 100%;
        width: 60px;
        flex-shrink: 0;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        background-color: #405159;
        fill: white;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn {
        margin-right: 10px;
        height: calc(100% - 20px);
      }

    }
  }
</style>
